import { Toaster } from "@/components/ui/sonner";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import LoginPage from "@/pages/LoginPage";
import ChangePasswordPage from "@/pages/ChangePasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import JobsListPage from "@/pages/JobsListPage";
import JobFormPage from "@/pages/JobFormPage";
import JobDetailPage from "@/pages/JobDetailPage";
import UploadResumesPage from "@/pages/UploadResumesPage";
import SettingsPage from "@/pages/SettingsPage";
import EmailHistoryPage from "@/pages/EmailHistoryPage";
import WhatsappChatPage from "@/pages/WhatsappChatPage";
import FluxosPage from "@/pages/FluxosPage";
import AvailabilityPage from "@/pages/AvailabilityPage";
import CadastrosPage from "@/pages/CadastrosPage";
import PublicJobsListPage from "@/pages/PublicJobsListPage";
import PublicJobDetailPage from "@/pages/PublicJobDetailPage";
import PublicVideoInterviewPage from "@/pages/PublicVideoInterviewPage";
import VideoInterviewHostPage from "@/pages/VideoInterviewHostPage";
import ComparisonPrintPage from "@/pages/ComparisonPrintPage";
import PublicInterviewConfirmPage from "@/pages/PublicInterviewConfirmPage";
import ReportsPage from "@/pages/ReportsPage";
import IntegracoesLinkedInPage from "@/pages/IntegracoesLinkedInPage";
import LinkedInInboxPage from "@/pages/LinkedInInboxPage";

import "@/App.css";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />

          {/* Public careers pages (no auth) */}
          <Route path="/carreiras/:slug" element={<PublicJobsListPage />} />
          <Route path="/c/:slug/:jobSlug" element={<PublicJobDetailPage />} />
          {/* Organization-scoped careers (new) */}
          <Route
            path="/carreiras/org/:slug"
            element={<PublicJobsListPage orgMode />}
          />
          <Route
            path="/c/org/:slug/:jobSlug"
            element={<PublicJobDetailPage orgMode />}
          />

          {/* Public video interview (candidate-facing magic link) */}
          <Route
            path="/entrevista-video/:interviewId"
            element={<PublicVideoInterviewPage />}
          />

          {/* Forced first-access / opt-in password change */}
          <Route
            path="/trocar-senha"
            element={
              <ProtectedRoute>
                <ChangePasswordPage />
              </ProtectedRoute>
            }
          />

          <Route
            element={
              <ProtectedRoute>
                <AppLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<DashboardPage />} />
            <Route path="/vagas" element={<JobsListPage />} />
            <Route path="/vagas/nova" element={<JobFormPage />} />
            <Route path="/vagas/:id/editar" element={<JobFormPage />} />
            <Route path="/vagas/:id" element={<JobDetailPage />} />
            <Route path="/vagas/:id/upload" element={<UploadResumesPage />} />
            <Route
              path="/entrevistas/:interviewId/sala"
              element={<VideoInterviewHostPage />}
            />
            <Route path="/comunicacoes/emails" element={<EmailHistoryPage />} />
            <Route path="/comunicacoes/whatsapp" element={<WhatsappChatPage />} />
            <Route path="/comunicacoes/fluxos" element={<FluxosPage />} />
            <Route path="/minha-agenda" element={<AvailabilityPage />} />
            <Route path="/cadastros" element={<CadastrosPage />} />
            <Route path="/relatorios" element={<ReportsPage />} />
            <Route path="/integracoes/linkedin" element={<IntegracoesLinkedInPage />} />
            <Route path="/comunicacoes/linkedin" element={<LinkedInInboxPage />} />
            <Route path="/configuracoes" element={<SettingsPage />} />
            <Route
              path="/comparacao/:id/imprimir"
              element={<ComparisonPrintPage />}
            />
          </Route>

          {/* Public candidate-facing pages (no auth) */}
          <Route
            path="/entrevista/confirmar/:interviewId"
            element={<PublicInterviewConfirmPage />}
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="bottom-right" />
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
